import { z } from 'zod'

/** Fila única de mensagens de texto entregues pelo WAHA. */
export const FILA_WHATSAPP_TRANSACIONAL = 'dv-whatsapp-transacional'

export const mensagemWhatsapp = z.object({
  destinatario: z.string().regex(/^\+[1-9]\d{7,14}$/, 'O destinatário do WhatsApp deve estar em E.164.'),
  texto: z.string().trim().min(1, 'A mensagem do WhatsApp está vazia.'),
})
export type MensagemWhatsapp = z.infer<typeof mensagemWhatsapp>
